var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.waiting)?_c('ClosedView',{attrs:{"errors":_vm.$shop.initErrors}}):_vm._e(),_c('Tracking',[(_vm.initialized || _vm.initError)?_c('div',[_c('router-view'),_c('Footer')],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }